import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBpZoUqDQlX0eNF351p_DwNBcO1jIc00MQ",
  authDomain: "notes-react-1bf24.firebaseapp.com",
  projectId: "notes-react-1bf24",
  storageBucket: "notes-react-1bf24.appspot.com",
  messagingSenderId: "546576671008",
  appId: "1:546576671008:web:ebac50b4a49d1374f8b745",
  measurementId: "G-0PFTQZYC18",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
